import type { Order } from "../../api/cart";
import { Badge, type BadgeTone } from "../ui";

/** The customer's words for each status (PRD 5.10). "Awaiting payment" is bank transfers only; cash on delivery starts confirmed. */
const STATUS: Record<Order["status"], { label: string; tone: BadgeTone }> = {
  pending_payment: { label: "Awaiting payment", tone: "low" },
  paid: { label: "Payment received", tone: "info" },
  confirmed: { label: "Order confirmed, pay on delivery", tone: "info" },
  packed: { label: "Being packed", tone: "info" },
  dispatched: { label: "On its way", tone: "stock" },
  completed: { label: "Completed", tone: "neutral" },
  cancelled: { label: "Cancelled", tone: "out" },
  returned: { label: "Returned to us", tone: "out" },
};

export function orderStatusLabel(order: Pick<Order, "status" | "fulfilment">) {
  if (order.fulfilment === "pickup" && order.status === "dispatched") return "Ready for pickup";
  if (order.fulfilment === "pickup" && order.status === "confirmed") return "Order confirmed, pay when you collect";
  return STATUS[order.status].label;
}

export function OrderStatusBadge({ order }: { order: Pick<Order, "status" | "fulfilment"> }) {
  return <Badge tone={STATUS[order.status].tone}>{orderStatusLabel(order)}</Badge>;
}
